<div class="wrapper">
  <div>
    Compose a guess by selecting one of the cards above
  </div>
  <div class="container" *ngIf="guess && guess.murdererUid">
    <ng-container *ngIf="gameApi.players$ | async as players">
      <ng-container *ngIf="getMurderer(players) as murderer">
        <div class="murderer">
          <div class="think">I think</div>
          <tg-avatar [diameter]="50" [uid]="murderer.uid"></tg-avatar>
          <div class="name">{{ murderer.name }}</div>
          <div class="subtitle">is the murderer</div>
        </div>
        <ng-container *ngIf="getMeansCard(murderer) as meansCard">
          <app-card [card]="meansCard" [means]="true"></app-card>
          <ng-container *ngIf="getClueCard(murderer) as clueCard">
            <app-card [card]="clueCard" [means]="false"></app-card>
            <div class="button-container">
              <button mat-raised-button color="accent" (click)="makeGuess()">Make Guess</button>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
